(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.messages');
    module.factory('OnlineBooking', [OnlineBookingFn]);

    // extended model for online bookings
    function OnlineBookingFn() {

        var OnlineBooking = function () {

            // default values
            this.contactInfo = null;
            this.createDate = null;
            this.appointmentDate = null;
            this.content = null;
            this.sendSMS = false;
            this.appointmentState = 0;
            this.isOnlineBooking = true;
            this.recurringAppointmentGuid = null;
            this.fK_User_Patient = null;
            this.patient = null;
            this.fK_Agenda = null;
            this.fK_AppointmentType = null;
            this.fK_AgendaLabel = null;
            this.deleted = false;
            this.times = null;
            this.callGuid = null;
            this.callerNumber = null;
        };

        // extend object
        OnlineBooking.prototype.extend = function (object) {
            var self = this;
            angular.extend(self, object);

            if (self.mobile === undefined || self.mobile === null) {
                self.mobile = { value: '' };
            }
        }; // extend

        // prepare for save
        OnlineBooking.prototype.prepareForSave = function () {
            var self = this;

            self.fK_User_Patient = self.patient ? self.patient.id : null;

            self.times.forEach(function (item) {
                delete item.appointment;
            });

            delete self.agendaLabel;
            delete self.appointmentType;
            delete self.agenda;
            delete self.patient;
        };

        return OnlineBooking;
    }
})();